const settingTypes = {
  number: 'NUMBER',//0
  string: 'STRING',//1
  boolean: 'BOOLEAN',//2
  inputList: 'INPUT_LIST',//3
  multipleSelectList: 'MULTIPLE_SELECT_LIST',//4
  forceBpm: 'FORCE_BPM',//5
  emailList: 'EMAIL_LIST',//6
  form: 'FORM',//7
  timeSpan: 'TIMESPAN', //8
  //formList: 'FORM_LIST',//9 пока решили что не нужно Планировали настройка из нескольких дубликатов форм. Например, для разных типов торгов
  singleSelectList: 'SINGLE_SELECT_LIST', //9
  html: 'HTML' //10
}

import OrganizerSettingApi from '@/api/organizerSettingApi'
const organizer_setting_api = new OrganizerSettingApi()

export default {
  data() {
    return {
      acessSettingTypes: [
        settingTypes.number,
        settingTypes.string,
        settingTypes.boolean,
        settingTypes.multipleSelectList,
        settingTypes.timeSpan,
        settingTypes.emailList,
        settingTypes.form,
        //settingTypes.formList,
        settingTypes.inputList,
        settingTypes.singleSelectList,
        settingTypes.html
      ],
      settingTypes: settingTypes
    }
  },
  methods: {
    async $_deleteSetting(item) {
      return await organizer_setting_api.deleteOrganizerSetting(item.settingOrganizationId)
    },
    $_getViewFormValue(settingValue) {
      if (!settingValue) {
        return []
      }
      let result = []
      JSON.parse(settingValue).forEach(settingValueItem => {
        let arrayItem = []
        Object.entries(settingValueItem).forEach(item => {
          arrayItem.push({
            key: item[0],
            value: item[1]
          })
        })
        result.push(arrayItem)
      })

      return result
    },
    $_defaultSettingValue(setting) {
      if (!setting) {
        return null
      }
      switch (setting.settingType) {
      case this.settingTypes.boolean:
      case this.settingTypes.forceBpm:
        return '-'
      case this.settingTypes.emailList:
      case this.settingTypes.inputList:
        return ['']
      case this.settingTypes.multipleSelectList:
        return []
      case this.settingTypes.form:
        return '{}'
      case this.settingTypes.number:
        return '0'
      /*case this.settingTypes.formList:
        return '[{}]'*/
      default:
        return null
      }
    }
  }
}
